export default "__VITE_ASSET__S88YM0OB__"